import i18n from 'src/i18n/index.js';
import { uid } from 'quasar';

class Declaration {
  constructor(params) {
    this.uid = uid();
    this.receivedDate = params.receivedDate;
    this.treatmentDate = new Date(params.treatmentDate);
    this.lastTreatmentDate = params.lastTreatmentDate;
    this.submittedBy = new SubmittedBy(params.submittedBy);
    this.declarationId = params.declarationId;
    this.recordId = params.recordId;
    this.invoiceId = params.invoiceId;
    this.receiverOfReimbursement = new ReceiverOfReimbursement(params.receiverOfReimbursement);

    this.careProvider = params.careProvider;
    this.declarationAmount = params.declarationAmount;
    this.compensatedAmount = params.compensatedAmount;
    this.uncompensatedAmount = params.uncompensatedAmount;
    this.excessAmount = params.excessAmount;

    this.contributionAmount = params.contributionAmount;
    this.statusKey = params.status;
    this.status = i18n.global.t(`healthcare-costs.status.${params.status}`);
    this.hasReadRights = params.hasReadRights;
    this.careType = params.careType;
    this.year = params.year;
    this.customerNumber = params.customerNumber;
    this.fullName = params.fullName;
  }
}

class ReceiverOfReimbursement {
  constructor(params) {
    this.isCustomerReceiver = params === 'D';
    this.isCareProviderReceiver = params === 'M';
    this.label = i18n.global.t(`declaration.receiver-of-reimbursement.${params}`);
  }
}
class SubmittedBy {
  constructor(params) {
    this.isSubmittedByCareProvider = params === 'Z';
    this.isSubmittedByCustomer = params === 'V';
    this.label = i18n.global.t(`declaration.submitted-by.${params}`);
  }
}

export { Declaration as default };
